//#endregion
//#region src/index.ts
var e = {
	messages: {
		en: {
			expertsCockpit: {
				tabTitles: {
					content: "Experts content",
					pull: "Experts hot topics",
					users: "Expert users",
					userDetail: "Expert user detail"
				},
				statuses: {
					draft: "Draft",
					published: "Published"
				},
				badge: "Status level",
				notAvailable: "Currently away",
				type: "Type",
				userSearchLabel: "Search for name, expertise and hashtags",
				userDetail: "User detail",
				userSelect: {
					all: "All",
					label_expert: "Expert",
					label_admin: "Assigned to"
				},
				searchLabel: "Search for headline or expert content ID",
				searchPullLabel: "Search for headline",
				columnSummary: "Article summary",
				columnExpert: "Expert",
				columnBrands: "Brands",
				columnSubmitForReviewDate: "Submitted for review",
				columnUpdatedAt: "Updated at",
				columnPublicationDate: "Publication date",
				columnArticleUrl: "Public article URL",
				columnHeadline: "Headline",
				share: "Share",
				expert: "Expert",
				profile: {
					articleId: "Article ID",
					articlePreviewUrl: "Article preview URL",
					copyToClipboardSuccess: "Copied to clipboard",
					copyToClipboardError: "Could not copy — please copy the value manually."
				},
				refreshTooltip: "Click to refresh articles list",
				contentStatus: {
					dropdownLabel: "Status",
					computed_updated_by_expert: "Updated by Expert",
					default: "All",
					draft: "Draft",
					ready_for_review: "Submitted by Expert",
					article_created: "Created",
					article_edited: "Edited",
					article_live: "Live",
					article_rejected: "Rejected",
					article_reserved: "Reserved"
				},
				preview: {
					infoToEditorialTeam: "Expert requests and comments to the editorial team",
					noContent: "Article content has not yet been generated",
					comments: "Internal note",
					videoNote: "Expert videos are raw material and must be finalized before publication.",
					note: "Note",
					articleWordCountAndReadingTime: "{words} words – {characters} characters – reading time: {minutes} min",
					tabs: {
						article: "Article",
						contentDelivery: "Content Delivery"
					},
					timeline: { empty: "No content delivery events yet" }
				},
				actions: {
					send: "Send",
					import: "Import",
					importDialogTitle: "Import Article",
					importSuccessMessage: "Article has been successfully imported",
					importErrorMessage: "Failed to import article",
					edit: "Edit",
					requestChange: "Request Change",
					requestChangeDialogTitle: "Suggest changes to the article",
					requestChangeSuccessMessage: "Change suggestion submitted succesfully",
					assign: "Assign",
					assignDialogTitle: "Assign Article To Admin",
					assignSuccessMessage: "Article assigned successfully",
					internalNote: "Internal Note",
					reject: "Reject",
					rejectDialogTitle: "Reject Article",
					rejectSuccessMessage: "Article rejected successfully",
					downloadVideoHook: "Download video hook",
					videoHookProcessing: "Video hook (processing)",
					downloadVideoAnswer: "Download video",
					videoAnswerProcessing: "Video (processing)",
					reminder: "Send reminder email",
					reminderDialogTitle: "Are you sure you want to send a reminder email to the expert?",
					reminderSuccessMessage: "Reminder email sent successfully",
					reminderTextPlaceholder: "Additional text to the expert",
					revoke: "Revoke",
					revokeDialogTitle: "Are you sure you want to revoke this content from the expert?",
					revokeCommentPlaceholder: "Optional comment for the expert",
					revokeSuccessMessage: "Content revoked successfully",
					editorialExchange: "Editorial exchange",
					editorialExchangeDialogTitle: "Editorial exchange",
					addNewNote: "Add new note",
					noteToExpert: "Note to expert",
					noteFromEditorialTeam: "Note from editorial team",
					noteCreated: "Note created",
					noteSaveSuccess: "Note saved",
					noteSaveError: "Failed to save note",
					detail: "Mehr Infos"
				},
				columnPrio: "Priority",
				columnStatus: "Status",
				columnDateCreated: "Date Created",
				columnDueDate: "Due Date",
				columnAreaOfExpertise: "Area of expertise",
				columnLevel: "Status level",
				columnGender: "Gender",
				columnCreatedAt: "Creation date",
				columnAssignedTo: "Assigned to",
				newHotTopic: "New Hot Topic",
				edit: "Edit",
				delete: "Delete",
				pullContentStatus: { topicRequested: "Topic Requested" },
				pullContentForm: {
					contentName: "Working title",
					searchByExpert: "Search for expert name, expertise and hashtags",
					briefing: "Briefing",
					internalNote: "Internal Note",
					hotTopicCreator: "Hot Topic Creator",
					dueDate: "Due Date",
					contentNameDescription: "Enter the preliminary headline here. The experts cannot edit it.",
					dueDateDescription: "Select the date after which you will definitely no longer be able to use this topic. Once that date has passed, the experts will no longer be able to edit the post.",
					searchByExpertDescription: "You can enter specific names or topics (e.g., data protection, gardening) to narrow down your search for experts. Choose only experts who are a good fit for your hot topic.",
					briefingDescription: "Let the experts know what the angle of the topic is, which content and structural aspects are particularly important to you, and which brand the post is intended for. A personal greeting and a brief introduction can increase the response rate.",
					internalNoteDescription: "Leave a note here for your colleagues or for yourself that won't be visible to the experts.",
					hotTopicCreatorDescription: "Select the person you want to be notified as soon as the hot topic has been edited.",
					jobTeamId: "Job team"
				},
				assignContentForm: { comment: "Comment" },
				category: "Category",
				prio: "Prio",
				prioOptions: {
					prio_0: "0 - (Evergreen)",
					prio_1: "1 - (24h)",
					prio_2: "2 - (1/3 Days)",
					prio_3: "3 - (1/7 Days)"
				},
				contentType: "Content Type",
				contentTypeOptions: {
					all: "All",
					text: "Text",
					video: "Video",
					qaarticle: "Q&A Article",
					qavideo: "Q&A Video",
					videoreact: "React Video",
					recycling: "Recycling Article",
					openformat: "Customised Article",
					videoopenformat: "Produced Video"
				},
				editHotTopic: "Edit Hot Topic",
				pullContentRequiredFields: "The hot topic cannot be saved as mandatory information is missing.",
				add: "Add",
				validators: { requiredCategoriesOrAssignToOrVisibleTo: "You must enter at least one of the fields categories and assign to or visible to" },
				dialogs: {
					confirmToCreatePullContentTitle: "Are you sure you want to create this hot topic?",
					confirmToCreatePullContentMessage: "Your topic suggestion will be visible to the selected experts in the next moment.",
					confirmToSendReminderTitle: "Are you sure you want to send a reminder to the Expert?",
					confirmToSendReminderMessage: "The expert will receive a reminder to complete the hot topic.",
					confirmToDeleteContentTitle: "Are you sure you want to delete the Content?",
					confirmToDeleteContentMessage: "This content will be deleted permanently"
				},
				notifications: {
					pullContentCreated: "Hot Topic created successfully",
					pullContentCreationFailed: "Failed to create Hot Topic",
					contentNotFound: "Content not found",
					pullContentEdited: "Hot Topic edited successfully",
					pullContentEditFailed: "Failed to edit Hot Topic",
					contentDeleted: "Content deleted successfully",
					contentDeleteFailed: "Failed to delete Content",
					contentReminderSent: "Reminder sent successfully",
					contentReminderSendFailed: "Failed to send reminder",
					expertInsertInfoBlockNotFound: "Experts info block has not been found",
					expertInsertInfoBlockDifferentBrand: "The imported experts info block has a different brand than the one it is imported to. Please check it in the article body.",
					expertInsertInfoBlockFailed: "Failed to insert experts info block"
				},
				sendReminder: "Send Reminder Email",
				tabs: {
					articles: "Articles",
					hotTopics: "Hot Topics",
					users: "Experts"
				},
				contentEvents: {
					remarkCreated: "Remark created",
					contentChangesNeeded: "Content Changes Needed",
					statusUpdate: "Status updated",
					statusUpdateDescription: "Status has been updated from {previousStatus} to {currentStatus}",
					contentStatus: "Content {status}",
					hotTopicRequesterCreate: "Hot topic requester created",
					contentPushToCtf: "Content pushed",
					contentPushToCtfDescription: "Content link:",
					adminReviewAssignment: "Assigned",
					adminReviewAssignmentDescription: "Content assigned for review to {assignedAdminFullName}",
					contentPick: "Content updated",
					contentPickDescription: "The expert has taken over the content.",
					contentRevoked: "Content revoked",
					contentRevokedDescription: "Content assignment revoked from {expertFullName}.",
					accepted: "Accepted",
					inPreparation: "In preparation",
					scheduled: "Scheduled",
					scheduledFor: "Scheduled for",
					submitted: "Submitted",
					openPublishedArticle: "Open article",
					brandForChannel: "{brand} for `{channel}` channel"
				},
				importForm: {
					additionalPageTags: "Additional tracking tags",
					additionalAdTags: "Additional ad tags"
				},
				badgeLevel: {
					"guest-author": "Guest author",
					expert: "Expert",
					"top-expert": "Top expert"
				}
			},
			expertsCockpitComponents: {
				feedback: {
					buttonLabel: "Send Feedback",
					formTitle: "Published Article Feedback",
					givePraise: "Give Special Praise",
					removePraise: "Remove Special Praise",
					specialPraiseInfo: "Give special praise so that the expert receives two additional tokens!",
					send: "Send",
					confirm: "Confirm",
					messagePublishNoFeedback: "Thanks for publishing this experts article. Be sure to come back and share your feedback with the expert - it will be greatly appreciated!",
					messagePublishTokenOnly: "Thanks for granting an extra token to the expert! You can still come back later and share your feedback.",
					messagePublishFeedbackOnly: "Thanks for sharing your feedback with the expert! You can still come back later and grant an extra token if you wish.",
					messagePublishFeedbackComplete: "Thanks for completing the feedback process - it is greatly appreciated!"
				},
				userWidget: {
					showContactsDetails: "Contact",
					contactsDetailsConfirmation: "Are you sure you want to contact the expert outside of the regular hot topic process? Please only use the direct route in exceptional cases.",
					contactDetails: "Contact details",
					email: "Email",
					phone: "Phone",
					biography: "Biography",
					unvailableFromTo: "Unavailable from {from} to {to}",
					dateJoined: "Date Joined",
					lastPublishedAt: "Last published article date",
					pullContentClaimTime: "Responds to Hot Topics within {time}",
					durationDays: "{n} day | {n} days",
					durationHours: "{n} hour | {n} hours"
				},
				engagement: {
					title: "Engagement",
					pullClaimTime: "Hot topic claim time",
					pullProcessingTime: "Hot topic processing time",
					contentTypePreference: "Content type preference",
					factcheckingClaimTime: "Factchecking claim time",
					factcheckingProcessingTime: "Factchecking processing time",
					factcheckingAverageFeedbackLoops: "Factchecking average feedback loops",
					factcheckingProcessedArticles: "Factchecking processed articles",
					assignedToRate: "Assigned to rate",
					visibleToRate: "Visible to rate"
				},
				incentivation: {
					title: "Incentivation",
					activeTokens: "Active tokens",
					passiveTokens: "Passive tokens",
					trafficTokens: "Traffic generated tokens",
					publicationsTokens: "Cockpit generated tokens"
				},
				pushContent: { title: "Proactive contribution" },
				pullContent: { title: "Hot topics" },
				publishedContents: {
					title: "Published contents",
					subtitle: "This shows the number of articles from the last six months."
				},
				comment: "Comment",
				deadline: "Deadline"
			}
		},
		de: {
			expertsCockpit: {
				tabTitles: {
					content: "Experten-Content",
					pull: "Experten-Hot-Topics",
					users: "Experten-Nutzer",
					userDetail: "Experten-Nutzerdetail"
				},
				statuses: {
					draft: "Entwurf",
					published: "Veröffentlicht"
				},
				badge: "Status-Level",
				notAvailable: "Derzeit abwesend",
				type: "Typ",
				userSearchLabel: "Suchen nach Namen, Fachgebiet und Hashtags",
				userDetail: "Benutzerdetail",
				userSelect: {
					all: "Alle",
					label_expert: "Experte",
					label_admin: "Zugeordnet zu"
				},
				searchLabel: "Suchen nach Überschrift oder Inhalts-ID",
				searchPullLabel: "Suchen nach Überschrift",
				columnSummary: "Artikel",
				columnExpert: "Experte",
				columnBrands: "Marken",
				columnSubmitForReviewDate: "Eingereicht",
				columnUpdatedAt: "Geändert",
				columnGender: "Geschlecht",
				columnCreatedAt: "Erstellungsdatum",
				columnPublicationDate: "Veröffentlichungsdatum",
				columnArticleUrl: "Öffentliche Artikel-URL",
				columnHeadline: "Überschrift",
				share: "Teilen",
				expert: "Experte",
				profile: {
					articleId: "Artikel-ID",
					articlePreviewUrl: "Artikel-Vorschau-URL",
					copyToClipboardSuccess: "In die Zwischenablage kopiert",
					copyToClipboardError: "Kopieren fehlgeschlagen — bitte den Wert manuell kopieren."
				},
				refreshTooltip: "Klicken Sie hier, um die Artikelliste zu aktualisieren",
				contentStatus: {
					dropdownLabel: "Status",
					computed_updated_by_expert: "Angepasst vom Experten",
					default: "Alle",
					draft: "Entwurf",
					ready_for_review: "Eingereicht von Experte",
					article_created: "Erstellt",
					article_edited: "Bearbeitet",
					article_live: "Veröffentlicht",
					article_rejected: "Abgelehnt",
					article_reserved: "Reserviert"
				},
				preview: {
					infoToEditorialTeam: "Expertenwünsche und -hinweise an die Redaktion",
					noContent: "Es wurden noch keine Artikelinhalte erstellt",
					comments: "Interne Notiz",
					videoNote: "Expertenvideos sind Rohmaterial und müssen vor der Veröffentlichung fertiggestellt werden.",
					note: "Hinweis",
					articleWordCountAndReadingTime: "{words} Wörter – {characters} Zeichen – Lesezeit: {minutes} Min.",
					tabs: {
						article: "Artikel",
						contentDelivery: "Beitragsverlauf"
					},
					timeline: { empty: "Noch keine Content-Delivery-Ereignisse" }
				},
				actions: {
					send: "Senden",
					import: "Importieren",
					importDialogTitle: "Artikel importieren",
					importSuccessMessage: "Artikel wurde erfolgreich importiert",
					importErrorMessage: "Fehler beim Importieren des Artikels",
					edit: "Artikel bearbeiten",
					requestChange: "Änderung anfordern",
					requestChangeDialogTitle: "Änderungen am Artikel vorschlagen",
					requestChangeSuccessMessage: "Änderungsvorschlag erfolgreich übermittelt",
					assign: "Zuweisen",
					assignDialogTitle: "Artikel dem Administrator zuweisen",
					assignSuccessMessage: "Artikel erfolgreich zugewiesen",
					internalNote: "Interne Notiz",
					reject: "Ablehnen",
					rejectDialogTitle: "Artikel ablehnen",
					rejectSuccessMessage: "Artikel erfolgreich abgelehnt",
					downloadVideoHook: "Video-Hook herunterladen",
					videoHookProcessing: "Video-Hook (wird verarbeitet)",
					downloadVideoAnswer: "Video herunterladen",
					videoAnswerProcessing: "Video (wird verarbeitet)",
					reminder: "Erinnerungs-E-Mail senden",
					reminderDialogTitle: "Willst du wirklich eine Erinnerungs-E-Mail an den Experten senden?",
					reminderSuccessMessage: "Erinnerungs-E-Mail erfolgreich gesendet",
					reminderTextPlaceholder: "Zusätzlicher Text an den Experten",
					revoke: "Inhalte entziehen",
					revokeDialogTitle: "Willst du dem Experten diesen Inhalt wirklich entziehen?",
					revokeCommentPlaceholder: "Optionaler Kommentar für den Experten",
					revokeSuccessMessage: "Inhalt erfolgreich entzogen",
					editorialExchange: "Nachricht an Experten",
					editorialExchangeDialogTitle: "Nachricht an Experten",
					addNewNote: "Neue Notiz hinzufügen",
					noteToExpert: "Notiz an Experten",
					noteFromEditorialTeam: "Notiz der Redaktion",
					noteCreated: "Notiz erstellt",
					noteSaveSuccess: "Notiz gespeichert",
					noteSaveError: "Notiz konnte nicht gespeichert werden",
					detail: "More Info"
				},
				columnPrio: "Priorität",
				columnStatus: "Status",
				columnDateCreated: "Erstellt am",
				columnDueDate: "Fällig am",
				columnAreaOfExpertise: "Fachgebiet",
				columnLevel: "Status-Level",
				columnAssignedTo: "Zugewiesen an",
				newHotTopic: "Neues Hot Topic",
				edit: "Bearbeiten",
				delete: "Löschen",
				pullContentStatus: { topicRequested: "Thema angefragt" },
				pullContentForm: {
					contentName: "Arbeitstitel",
					searchByExpert: "Suchen nach Experte, Fachgebiet und Hashtags",
					briefing: "Briefing",
					internalNote: "Interne Notiz",
					hotTopicCreator: "Hot Topic Ersteller",
					dueDate: "Fällig am",
					contentNameDescription: "Hier die vorläufige Überschrift eintragen. Die Expert:innen können sie nicht anpassen.",
					dueDateDescription: "Wähle das Datum, ab dem du das Thema definitiv nicht mehr verwenden kannst. Sobald dieses Datum erreicht ist, können die Expert:innen den Beitrag nicht mehr bearbeiten.",
					searchByExpertDescription: "Du kannst entweder konkrete Namen oder Themen (z. B. Datenschutz, Garten) eingeben, um die Expertensuche einzugrenzen. Wähle ausschließlich Expert:innen aus, die zu deinem Hot Topic passen.",
					briefingDescription: "Gib den Expert:innen mit, was der Aufhänger des Themas ist, welche inhaltlichen und strukturellen Aspekte dir besonders wichtig sind und für welche Marke der Beitrag vorgesehen ist. Eine persönliche Anrede sowie ein kurzer Gruß können die Antwortrate erhöhen.",
					internalNoteDescription: "Hinterlasse hier einen Hinweis für deine Kolleg:innen oder für dich selbst, der für die Expert:innen nicht sichtbar ist.",
					hotTopicCreatorDescription: "Wähle die Person aus, die benachrichtigt werden soll, sobald das Hot Topic bearbeitet wurde.",
					jobTeamId: "Job-Team"
				},
				assignContentForm: { comment: "Kommentar" },
				category: "Kategorie",
				prio: "Prio",
				prioOptions: {
					prio_0: "0 - (Evergreen)",
					prio_1: "1 - (24h)",
					prio_2: "2 - (1/3 Tage)",
					prio_3: "3 - (1/7 Tage)"
				},
				contentType: "Inhaltstyp",
				contentTypeOptions: {
					all: "Alle",
					text: "Text",
					video: "Video",
					qaarticle: "Q&A-Artikel",
					qavideo: "Q&A-Video",
					videoreact: "React-Video",
					recycling: "Recycling Artikel",
					openformat: "Individueller Artikel",
					videoopenformat: "Produziertes Video"
				},
				editHotTopic: "Hot Topic bearbeiten",
				pullContentRequiredFields: "Das Hot Topic kann nicht gespeichert werden, weil Pflichtinformationen fehlen.",
				add: "Hinzufügen",
				validators: { requiredCategoriesOrAssignToOrVisibleTo: "Sie müssen mindestens eines der Felder „Kategorien“ und „Zuweisen zu“ oder „Sichtbar für“ ausfüllen." },
				dialogs: {
					confirmToCreatePullContentTitle: "Willst du dieses Hot Topic wirklich erstellen?",
					confirmToCreatePullContentMessage: "Im nächsten Moment wird dein Themenvorschlag für die ausgewählten Experten sichtbar. ",
					confirmToDeleteContentTitle: "Sind Sie sicher, dass Sie den Inhalt löschen möchten?",
					confirmToDeleteContentMessage: "Dieser Inhalt wird dauerhaft gelöscht",
					confirmToSendReminderTitle: "Sind Sie sicher, dass Sie einen Erinnerungsnachricht an den Experten senden möchten?",
					confirmToSendReminderMessage: "Der Experte wird eine Erinnerung erhalten, um das Hot Topic zu bearbeiten."
				},
				notifications: {
					pullContentCreated: "Hot Topic erfolgreich erstellt",
					pullContentCreationFailed: "Fehler beim Erstellen des Hot Topic",
					contentNotFound: "Inhalt nicht gefunden",
					pullContentEdited: "Hot Topic erfolgreich bearbeitet",
					pullContentEditFailed: "Fehler beim Bearbeiten des Hot Topic",
					contentDeleted: "Inhalt erfolgreich gelöscht",
					contentDeleteFailed: "Fehler beim Löschen des Inhalts",
					contentReminderSent: "Erinnerungsnachricht erfolgreich gesendet",
					contentReminderSendFailed: "Fehler beim Senden der Erinnerungsnachricht",
					expertInsertInfoBlockNotFound: "Experten-Infoblock nicht gefunden",
					expertInsertInfoBlockDifferentBrand: "Der importierte Infoblock zum Experten hat eine andere Marke als die, für die importiert wird. Bitte im Artikeltext überprüfen.",
					expertInsertInfoBlockFailed: "Einfügen des Experten-Infoblocks fehlgeschlagen"
				},
				sendReminder: "E-Mail an Experten senden",
				tabs: {
					articles: "Artikel",
					hotTopics: "Hot Topics",
					users: "Experten"
				},
				contentEvents: {
					remarkCreated: "Bemerkung hinzugefügt",
					contentChangesNeeded: "Änderungen am Inhalt erforderlich",
					statusUpdate: "Status aktualisiert",
					statusUpdateDescription: "Status wurde von {previousStatus} auf {currentStatus} aktualisiert",
					contentStatus: "Content {status}",
					hotTopicRequesterCreate: "Hot Topic erstellt",
					contentPushToCtf: "Inhalt übertragen",
					contentPushToCtfDescription: "Inhalt-Link:",
					adminReviewAssignment: "Zugewiesen",
					adminReviewAssignmentDescription: "Beitrag zur Bearbeitung zugewiesen an {assignedAdminFullName}",
					contentPick: "Hot Topic angenommen",
					contentPickDescription: "Der Experte hat den Inhalt übernommen.",
					contentRevoked: "Inhalt wurde widerrufen",
					contentRevokedDescription: "Inhaltszuweisung von {expertFullName} widerrufen.",
					accepted: "Akzeptiert",
					inPreparation: "In Vorbereitung",
					scheduled: "Geplant",
					scheduledFor: "Geplant für",
					submitted: "Eingereicht",
					openPublishedArticle: "Artikel öffnen",
					brandForChannel: "{brand} für `{channel}` Channel"
				},
				importForm: {
					additionalPageTags: "Zusätzliche Tracking-Tags",
					additionalAdTags: "Zusätzliche Werbe-Tags"
				},
				badgeLevel: {
					"guest-author": "Gastautor",
					expert: "Experte",
					"top-expert": "Top-Experte"
				}
			},
			expertsCockpitComponents: {
				feedback: {
					buttonLabel: "Feedback senden",
					formTitle: "Feedback zum veröffentlichten Artikel",
					givePraise: "Besonderes Lob aussprechen",
					removePraise: "Besonderes Lob entfernen",
					specialPraiseInfo: "Sprechen Sie ein besonderes Lob aus, damit der Experte zwei zusätzliche Token erhält!",
					send: "Senden",
					confirm: "Bestätigen",
					messagePublishNoFeedback: "Vielen Dank für die Veröffentlichung des Artikels des Experten. Kommen Sie gern später zurück und teilen Sie Ihr Feedback mit dem Experten - es wird sehr geschätzt!",
					messagePublishTokenOnly: "Vielen Dank, dass Sie dem Experten zwei zusätzliche Tokens gewährt haben! Sie können später jederzeit zurückkommen und Ihr Feedback teilen.",
					messagePublishFeedbackOnly: "Vielen Dank für Ihr Feedback an den Experten! Sie können später jederzeit zurückkommen und bei Bedarf einen zusätzlichen Token vergeben.",
					messagePublishFeedbackComplete: "Vielen Dank, dass Sie den Feedback-Prozess abgeschlossen haben - das wird sehr geschätzt!"
				},
				userWidget: {
					showContactsDetails: "Kontakt",
					contactsDetailsConfirmation: "Willst du den oder die Expert:in wirklich außerhalb des regulären Hot-Topic-Prozesses kontaktieren? Bitte den direkten Weg nur in Ausnahmefällen benutzen.",
					contactDetails: "Kontaktdaten",
					email: "E-Mail",
					phone: "Telefon",
					biography: "Biographie",
					unvailableFromTo: "Nicht verfügbar von {from} bis {to}",
					dateJoined: "Beitrittsdatum ",
					lastPublishedAt: "Datum der letzten Veröffentlichung des Artikels",
					pullContentClaimTime: "Reagiert innerhalb von {time} auf Hot Topics",
					durationDays: "{n} Tag | {n} Tagen",
					durationHours: "{n} Stunde | {n} Stunden"
				},
				engagement: {
					title: "Engagement",
					pullClaimTime: "Hot-Topic-Anforderungszeit",
					pullProcessingTime: "Hot-Topic-Verarbeitungszeit",
					contentTypePreference: "Inhaltstyp-Präferenz",
					factcheckingClaimTime: "Factchecking Anforderungszeit",
					factcheckingProcessingTime: "Factchecking Verarbeitungszeit",
					factcheckingAverageFeedbackLoops: "Factchecking durchschnittliche Feedback-Schleifen",
					factcheckingProcessedArticles: "Factchecking verarbeitete Artikel",
					assignedToRate: "Zugewiesen an Rate",
					visibleToRate: "Sichtbar für Rate"
				},
				incentivation: {
					title: "Incentivierung",
					activeTokens: "Aktive Tokens",
					passiveTokens: "Passive Tokens",
					trafficTokens: "Traffic-generierte Tokens",
					publicationsTokens: "Cockpit-generierte Tokens"
				},
				pushContent: { title: "Proaktive Beiträge" },
				pullContent: { title: "Hot Topics" },
				publishedContents: {
					title: "Veröffentlichte Inhalte",
					subtitle: "Hier wird die Beitragsanzahl der letzten sechs Monate angezeigt."
				},
				comment: "Kommentar",
				deadline: "Deadline"
			}
		}
	},
	routes: [{
		path: "/experts-cockpit",
		children: [
			{
				path: "",
				name: "experts_cockpit_content_tab",
				component: () => import("./experts-content-tab.view-mkp2drwf.js"),
				meta: { requiredRight: "experts-cockpits:navigate" },
				redirect: {
					name: "experts_cockpit_content_tab_list",
					replace: !0
				},
				children: [
					{
						path: "tab/content",
						name: "experts_cockpit_content_tab_list",
						props: { title: "expertsCockpit.tabTitles.content" },
						component: () => import("./experts-content-list-CXjufFGK.js")
					},
					{
						path: "tab/pull",
						name: "experts_cockpit_pull_tab_list",
						props: { title: "expertsCockpit.tabTitles.pull" },
						component: () => import("./experts-pull-content.list-CskaisWD.js")
					},
					{
						path: "tab/user",
						name: "experts_cockpit_user_tab_list",
						props: { title: "expertsCockpit.tabTitles.users" },
						component: () => import("./experts-user-list-DCA2yAD_.js")
					}
				]
			},
			{
				path: "pull",
				meta: { requiredRight: "experts-cockpits:navigate" },
				children: [{
					path: "new",
					name: "experts_cockpit_pull_new",
					component: () => import("./experts-pull-content-edit.view-SmX6WMcP.js")
				}, {
					path: ":id",
					name: "experts_cockpit_pull_edit",
					component: () => import("./experts-pull-content-edit.view-SmX6WMcP.js"),
					props: (e) => ({ id: e.params.id })
				}]
			},
			{
				path: "user",
				meta: { requiredRight: "experts-cockpits:navigate" },
				children: [{
					path: "detail/:id",
					name: "experts_cockpit_user_detail",
					component: () => import("./experts-user-detail.view-sS25cgIN.js"),
					props: (e) => ({
						id: e.params.id,
						title: "expertsCockpit.tabTitles.userDetail"
					})
				}]
			}
		]
	}]
};
//#endregion
export { e as expertsCockpitModule };

//# sourceMappingURL=index.es.js.map